import { FC, useMemo } from 'react'
import { InsightPostAvatar } from 'components/features/insights/InsightPostAvatar/InsightPostAvatar'
import { WithPostUid } from 'interfaces/feed'
import { createPostAuthorSelector } from 'selectors/feedSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { InsightPostCTALink } from 'components/features/insights/InsightPostCTALink/InsightPostCTALink'
import { FeedUserInfoLayout } from 'components/features/socialFeed/FeedUserInfoLayout/FeedUserInfoLayout'

type InsightPostUserInfoProps =
  & WithPostUid

export const InsightPostUserInfo: FC<InsightPostUserInfoProps> = (props) => {
  const { postUid, children } = props
  const postAuthorSelector = useMemo(
    createPostAuthorSelector,
    [postUid]
  )
  const author = useStoreSelector((state) => postAuthorSelector(state, { postUid }))

  const avatarChild = useMemo(() => author && (
    <InsightPostCTALink postUid={ postUid }>
      <InsightPostAvatar avatarId={ author.avatarId } />
    </InsightPostCTALink>
  ), [postUid, author])

  const userNameChild = useMemo(() => author && (
    <InsightPostCTALink postUid={ postUid }>
      { author.username }
    </InsightPostCTALink>
  ), [author, postUid])

  if (!author) {
    return null
  }

  return (
    <FeedUserInfoLayout
      mode='post'
      avatarChild={ avatarChild }
      userNameChild={ userNameChild }
      dateChild='Sponsored'
      badges={ author.badges }
    >
      { children }
    </FeedUserInfoLayout>
  )
}
